import { format } from "date-fns";

const formatCalendarDateUTC = (epoch) => {
  const date = new Date(epoch);
  date.setMinutes(date.getMinutes() + date.getTimezoneOffset());

  return format(date, "MMM do, yyyy");
};

export const generateSlateData = ({ submissions, currentJob, selectedSlateOptions }) => {
  const submissionData = submissions.map((submission) => {
    return {
      id: submission.id,
      status: submission.status,
      candidate: submission.candidate,
      varinerScore: submission.varinerScore,
      responses: [
        {
          question: "Why I am interested in this opportunity",
          answer: submission.customTextBlock1
        },
        {
          question: "My relevant work experience",
          answer: submission.customTextBlock3
        },
        {
          question: "Why I am interested in the location",
          answer: submission.customTextBlock2
        },
        {
          question: "Earliest Start Date",
          answer: formatCalendarDateUTC(submission.customDate1)
        },
        {
          question: "Ideal Start Date",
          answer: formatCalendarDateUTC(submission.customDate1)
        }
      ]
    };
  });

  const data = {
    submissions: submissionData,
    jobId: currentJob.id,
    jobTitle: currentJob.publicName,
    clientCorporation: currentJob.clientCorporation,
    options: {
      slateCover: selectedSlateOptions.indexOf("slateCover") > -1,
      summary: selectedSlateOptions.indexOf("summary") > -1,
      submissionQA: selectedSlateOptions.indexOf("submissionQA") > -1
    }
  };

  return data;
};
